module.exports = __webpack_public_path__ + "media/Components/fonts/Bitter-fdfe9d416626fbc3fddcca10b71b3f48.ttf";